<form>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="automaticFilteringOnIncomingCall">
         <input
            type="checkbox"
            id="automaticFilteringOnIncomingCall"
            [checked]="automaticFilteringOnIncomingCall$ | async"
            (click)="changeAutomaticFilteringOnIncomingCall($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{
            'brick.brick_definitions.call_history_browser.settings.automatic_filtering_on_incoming_call_label'
               | translate
         }}
      </label>
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="retainFilterOnCallFinish">
         <input
            type="checkbox"
            id="retainFilterOnCallFinish"
            [checked]="retainFilterOnCallFinish$ | async"
            (click)="changeRetainFilterOnCallFinish$($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.call_history_browser.settings.retain_filter_on_call_finish_label' | translate }}
      </label>
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showPrimaryFullDateFormat">
         <input
            type="checkbox"
            id="showPrimaryFullDateFormat"
            [checked]="showPrimaryFullDateFormat$ | async"
            (click)="changeShowPrimaryFullDateFormat$($event.currentTarget.checked)"
            class="k-checkbox"
         />{{ 'brick.brick_definitions.call_history_browser.settings.show_primary_full_date' | translate }}
      </label>
   </div>
</form>
